'use strict';

require('custom-event-polyfill');

require('usertiming');

require('navigator.sendbeacon');


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/polyfills.js
// module id = 496
// module chunks = 4